import UnidadeService from   "@/service/v10/sigap/UnidadeService"  

class Alocacao {  
 
    public static campos = () => {
        return [  
            
            {
                nome: "UnidadeId",
                type: "selectajax",
                label: "Unidade",
                sm: 6,
                lg: 6, 
                disabled: false,
                api: {
                    id: 'id',
                    label: 'descricao',
                    service: new UnidadeService(),
                    method: 'getTodos',
                } 
            },  
               
        ];
    }   
}
  
export   {   Alocacao }; 